<template>
  <div>
    <b-overlay
      :show="spinner"
      spinner-variant="primary"
    >
      <b-card>
        <categoriasForm
          categoriaSubmit="Crear Categoría"
          :categoria="categoriaData"
          @processCategoria="agregarCategoria"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>

import { BCard, BOverlay } from 'bootstrap-vue'
import { mapActions } from 'vuex'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const categoriasForm = () => import('@/layouts/components/Categorias/CategoriasForm.vue')

export default {
  components: {
    BCard,
    categoriasForm,
    BOverlay,
  },
  data() {
    return {
      spinner: false,
      categoriaData: {
        nombre: '',
        estado: null,
      },
    }
  },
  methods: {
    ...mapActions({ createCategoria: 'categorias/addCategorias' }),
    agregarCategoria(categoria) {
      this.spinner = true
      this.createCategoria(categoria).then(() => {
        const errorCategorias = store.state.categorias
        const errorMessage = errorCategorias.errorMessage.errors
        if (!errorCategorias.error) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Categoría creada con éxito 👍',
              icon: 'CheckIcon',
              text: `La categoría "${categoria.nombre}" fue creada con éxito!`,
              variant: 'success',
            },
          },
          {
            timeout: 4000,
          })

          this.$router.replace({
            name: 'categorias',
          })
        } else if (errorMessage.nombre) {
          this.$swal({
            title: 'Error!',
            text: `${errorMessage.nombre[0]}!`,
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
        } else {
          this.$swal({
            title: 'Error!',
            text: 'Ingreso de datos fraudulento!',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
        }
        this.spinner = false
      })
    },
  },
}
</script>
